const theme = {
  typograph: {
    small: 'font-size: 14px; font-weight: 300',
    smallBold: 'font-size: 14px; font-weight: 700',
    medium: 'font-size: 16px !important; font-weight: 300',
    mediumBold: 'font-size: 16px !important; font-weight: 700',
    largerBold: 'font-size: 18px !important; font-weight: 700',
  },
  fontSize: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '24px',
  },
  spacing: {
    sm: '10px',
    md: '16px',
    lg: '24px',
  },
  color: {
    primary: '#0182cd',
    neutral: '#121212',
    neutral90: '#515151',
    neutral80: '#9B9B9B',
    neutral60: '#CDCDCD',
    neutral20: '#F7F7F7',
    white: '#FFFFFF',
    success: '#00D604',
    error: '#FF253A',
    alert: '#FF8A00',
    warn: '#F9C52E',
    warn20: '#FFF8D9',
  },
} as const;

export default theme;
